import React, { useEffect, useRef } from "react";
import lottie from "lottie-web/build/player/lottie_light"; // Import lottie directly

export const Animations = ({ animation }) => {
  const animationContainer = useRef(null);

  useEffect(() => {
    if (!animationContainer.current) return;

    const anim = lottie.loadAnimation({
      container: animationContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animation,
    });

    return () => {
      anim.destroy();
    };
  }, [animation]); // Specify animation as a dependency

  return (
    <div
      className="animation-container"
      // style={{ height, width }}
      ref={animationContainer}
    />
  );
};